export default "/images/cloud-rain.svg?d2464f1a0526d4c55e659d05e2009270";